//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from "@/api";
import { mapState, mapMutations } from "vuex";

export default {
  name: 'ChickenRoadHistory',
  data() {
    return {
      isLoading: false,
      preloadGames: new Array(20),
      historyPageGames: [],
      isLg: false
    };
  },
  mounted() {
    this.checkMediaQuery();
    window.addEventListener('resize', this.checkMediaQuery);
    this.loadHistoryData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMediaQuery);
    if (this.chickenRoadState && Array.isArray(this.chickenRoadState.historyPageGames)) {
      this.chickenRoadState.historyPageGames = [];
    }
  },
  computed: {
    ...mapState(["user"]),
    currencyType() {
      return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
    },
    currencyTypeLabel() {
      if (this.currencyType === 1) return '欢乐豆';
      if (this.currencyType === 2) return '金豆';
      return '现金';
    },
    chickenRoadRouteName() {
      if (this.currencyType === 1) return 'happyCoinChickenRoad';
      if (this.currencyType === 2) return 'coin1ChickenRoad';
      return 'chicken-road';
    },
  },
  methods: {
    checkMediaQuery() {
      // 匹配 lg 响应式断点 (992px)
      this.isLg = window.innerWidth <= 992;
    },
    async loadHistoryData() {
      // 模拟加载历史记录逻辑
      this.isLoading = true;
      const response = await api.chickenRoadUserGames({ userId: this.user.id, currencyType: this.currencyType });
      const rawGames = response?.data?.data?.games || [];

      this.historyPageGames = rawGames;
      this.isLoading = false;

    },
    getModeText(mode) {
      const modeMap = {
        0: '简单',
        1: '中等',
        2: '困难'
      };
      return modeMap[mode] || mode;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;

      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${hours}:${minutes} ${day}.${month}.${year}`;
    },
    formatBet(amount) {
      const num = parseFloat(amount) || 0;
      return num.toString();
    },
    formatWin(game) {
      const isWin = game.status === 2;
      const amount = parseFloat(game.amount) || 0;
      const ratio = parseFloat(game.ratio || '0');

      if (isWin) {
        const totalWin = amount * ratio;
        return totalWin.toFixed(2);
      } else {
        return '0';
      }
    }
  }
};
